/* Luvie — Cart Drawer */

class CartDrawer {
  constructor() {
    this.drawer = document.querySelector('.cart-drawer');
    this.overlay = document.getElementById('overlay');
    this.itemsEl = document.querySelector('.cart-items');
    this.subtotalEl = document.querySelector('.cart-subtotal-amount');
    this.countLabelEl = document.querySelector('.cart-count-label');
    if (!this.drawer) return;
    this.bind();
    this.refresh();
  }

  bind() {
    document.querySelectorAll('[data-cart-open]').forEach(el =>
      el.addEventListener('click', e => { e.preventDefault(); this.open(); })
    );

    const closeBtn = this.drawer.querySelector('.cart-close-btn');
    if (closeBtn) closeBtn.addEventListener('click', () => this.close());

    if (this.overlay) this.overlay.addEventListener('click', () => this.close());

    document.addEventListener('submit', e => {
      const form = e.target.closest('[data-atc-form]');
      if (form) { e.preventDefault(); this.addToCart(form); }
    });

    this.drawer.addEventListener('click', e => {
      if (e.target.closest('[data-remove-key]')) {
        e.preventDefault();
        const key = e.target.closest('[data-remove-key]').dataset.removeKey;
        this.changeQty(key, 0);
      }
    });

    this.drawer.addEventListener('click', e => {
      const btn = e.target.closest('.qty-btn[data-action]');
      if (!btn) return;
      const item = btn.closest('[data-item-key]');
      if (!item) return;
      const key = item.dataset.itemKey;
      const display = item.querySelector('.qty-val');
      let val = parseInt(display.textContent, 10);
      if (btn.dataset.action === 'increase') val++;
      if (btn.dataset.action === 'decrease') val = Math.max(0, val - 1);
      display.textContent = val;
      this.changeQty(key, val);
    });
  }

  open() {
    this.drawer.classList.add('open');
    if (this.overlay) this.overlay.classList.add('active');
    document.body.style.overflow = 'hidden';
    this.refresh();
  }

  close() {
    this.drawer.classList.remove('open');
    if (this.overlay) this.overlay.classList.remove('active');
    document.body.style.overflow = '';
  }

  async refresh() {
    try {
      const cart = await fetch('/cart.js').then(r => r.json());
      this.render(cart);
    } catch (_) {}
  }

  render(cart) {
    if (!this.itemsEl) return;

    if (this.countLabelEl) this.countLabelEl.textContent = cart.item_count;

    const footer = this.drawer.querySelector('.cart-drawer-footer');

    if (cart.item_count === 0) {
      this.itemsEl.innerHTML = `
        <div class="cart-empty">
          <div class="cart-empty-icon">
            <span class="material-symbols-rounded">nights_stay</span>
          </div>
          <p>Your cart is feeling sleepy…</p>
          <a href="/collections/all" class="btn btn-primary" style="margin-top:0.5rem;font-size:0.85rem">
            Shop Night Lights
          </a>
        </div>`;
      if (footer) footer.style.display = 'none';
    } else {
      this.itemsEl.innerHTML = cart.items.map(i => this.itemHTML(i)).join('');
      if (footer) footer.style.display = '';
    }

    if (this.subtotalEl) this.subtotalEl.textContent = formatMoney(cart.total_price);

    document.querySelectorAll('.cart-count').forEach(el => {
      el.textContent = cart.item_count;
      el.classList.toggle('visible', cart.item_count > 0);
    });
  }

  itemHTML(item) {
    const imgSrc = item.featured_image?.url || '';
    const variantLine = item.variant_title && item.variant_title !== 'Default Title'
      ? `<div class="cart-item-variant">${item.variant_title}</div>` : '';

    return `
      <div class="cart-item" data-item-key="${item.key}">
        <div class="cart-item-img">
          ${imgSrc ? `<img src="${imgSrc}" alt="${item.product_title}" loading="lazy">` : ''}
        </div>
        <div>
          <div class="cart-item-name">${item.product_title}</div>
          ${variantLine}
          <div class="cart-item-qty">
            <button class="qty-btn" data-action="decrease" aria-label="Remove one">−</button>
            <span class="qty-val">${item.quantity}</span>
            <button class="qty-btn" data-action="increase" aria-label="Add one">+</button>
          </div>
          <a href="#" class="cart-item-remove" data-remove-key="${item.key}">Remove</a>
        </div>
        <div class="cart-item-line-price">${formatMoney(item.final_line_price)}</div>
      </div>`;
  }

  async addToCart(form) {
    const submitBtn = form.querySelector('[type="submit"]');
    const originalLabel = submitBtn?.innerHTML;

    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.innerHTML = '<span class="spinner"></span>';
    }

    try {
      const formData = new FormData(form);
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          id: formData.get('id'),
          quantity: parseInt(formData.get('quantity') || '1', 10)
        })
      });

      if (!res.ok) {
        const err = await res.json();
        alert(err.description || 'Could not add to cart.');
        return;
      }

      this.open();
    } catch (_) {
      alert('Something went wrong. Please try again.');
    } finally {
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.innerHTML = originalLabel;
      }
    }
  }

  async changeQty(key, quantity) {
    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity })
      });
      this.refresh();
    } catch (_) {}
  }
}

function formatMoney(cents) {
  return '$' + (cents / 100).toFixed(2);
}

document.addEventListener('DOMContentLoaded', () => {
  window.cartDrawer = new CartDrawer();
});
